export const PageTile = 'MangaDaily - Đọc Truyện Tranh Manga, Manhwa, Manhua Online'
export const PageDescription = 'MangaDaily - trang đọc truyện tranh số một tại Việt Nam, luôn đón đầu với việc cập nhật chương mới hàng giờ'